import { all, call, put, takeLatest ,select} from 'redux-saga/effects';
import {
  loginUser as loginUserService,
  sendGoogleLogin as sendGoogleLoginService,
} from '../services';

import { setAuthToken, setUserInfo, resetUserInfo,} from '../actions';

/**
 * Login
 */
function* loginUser({ payload }) {
  const { email, password, history } = payload;
  try {
    const result = yield call(loginUserService, email, password);
    const { authorization } = result.headers;
    const { operatorDetails } = result.body;

    console.log({ result }, 'loginsaga result');
    yield put(setUserInfo(operatorDetails));
    yield put(setAuthToken(authorization));
    yield call(history.push, '/home');
  } catch (err) {
    console.log(err);
  }
}

function* googleLoginUser({ payload }) {
  const { token, history } = payload;
  try {
    const result = yield call(sendGoogleLoginService, token);
    const { authorization } = result.headers;
    const { operatorDetails } = result.body;

    console.log({ result }, 'loginsaga result');
    yield put(setUserInfo(operatorDetails));
    yield put(setAuthToken(authorization));
    const urlFromOps = yield select((state) => state.user.urlFromOps);

    if (urlFromOps) {
      // Redirect to the saved URL if it exists
      yield call(history.push, urlFromOps);
    } else {
      // Default redirect
      yield call(history.push, '/home');
    }
  } catch (err) {
    console.log(err);
  }
}

function* logoutUser({ payload }) {
  const { history } = payload;
  try {
    yield put(resetUserInfo());
    yield call(history.push, '/');
  } catch (err) {
    console.log(err);
  }
}

/**
 * User Sagas
 */
export default function* root() {
  yield all([takeLatest('LOGIN_USER', loginUser)]);
  yield all([takeLatest('LOGOUT_USER', logoutUser)]);
  yield all([takeLatest('GOOGLE_LOGIN_USER', googleLoginUser)]);
}
